import {
  branchColumnDefinition,
  countryCodeColumnDefinition,
  enabledFlagColumnDefinition,
  goldIdColumnDefintion,
  legalEntityColumnDefinition,
  legalEntityDescriptionColumnDefinition,
  localTaxTypeColumnDefinition,
  minorityPercentageColumnDefinition,
  usTaxTypeColumnDefinition,
  sourceColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
} from '../columnDefinitions';
import {
  ownershipColumnDefinitionFactory,
  parentColumnDefinitionFactory,
} from '../columnDefinitionGenerators';

const legalEntitiesColumsBeforeSource = [
  diagnosticsSeverityColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
  { ...legalEntityColumnDefinition, headerName: 'Legal Entity' },
  legalEntityDescriptionColumnDefinition,
  enabledFlagColumnDefinition,
  usTaxTypeColumnDefinition,
  localTaxTypeColumnDefinition,
  branchColumnDefinition,
];

const legalEntitiesColumsAfterSource = [
  goldIdColumnDefintion,
  countryCodeColumnDefinition,
  minorityPercentageColumnDefinition,
  parentColumnDefinitionFactory(1),
  ownershipColumnDefinitionFactory(1),
  parentColumnDefinitionFactory(2),
  ownershipColumnDefinitionFactory(2),
  parentColumnDefinitionFactory(3),
  ownershipColumnDefinitionFactory(3),
  parentColumnDefinitionFactory(4),
  ownershipColumnDefinitionFactory(4),
  parentColumnDefinitionFactory(5),
  ownershipColumnDefinitionFactory(5),
  parentColumnDefinitionFactory(6),
  ownershipColumnDefinitionFactory(6),
  parentColumnDefinitionFactory(7),
  ownershipColumnDefinitionFactory(7),
  parentColumnDefinitionFactory(8),
  ownershipColumnDefinitionFactory(8),
  parentColumnDefinitionFactory(9),
  ownershipColumnDefinitionFactory(9),
  parentColumnDefinitionFactory(10),
  ownershipColumnDefinitionFactory(10),
];

export const legalEntitiesWithSourceColumnDefinitions = [
  ...legalEntitiesColumsBeforeSource,
  sourceColumnDefinition,
  ...legalEntitiesColumsAfterSource,
];

export const importLegalEntitiesWithSourceColumnDefinitions = legalEntitiesWithSourceColumnDefinitions.slice(2);

export default legalEntitiesWithSourceColumnDefinitions;
